import React from 'react';
import { MOBILE_BREAKPOINT } from '../../constants';
import { useHook } from '../../hooks';
import { useResized } from '../../hooks/common';
import { SupportEntrySubCategory } from '../../models';
import { getFileTypeIcon, getProductFileImage } from '../../services';
import Flex, { FlexDirection, FlexJustification, FlexWrap } from '../common/Flex';
import Icon, { IconType } from '../common/Icon';
import Link from '../common/Link';
import Tooltip from '../common/Tooltip';

export interface SupportEntrySubcategoryCardProps {
    supportEntrySubcategory: SupportEntrySubCategory;
}

const SupportEntrySubcategoryCard = ({ supportEntrySubcategory }: SupportEntrySubcategoryCardProps) => {
    const mobileView = useResized(x => x <= MOBILE_BREAKPOINT);
    const { handleFileGet } = useHook(x => x.products)();
    const iconType = supportEntrySubcategory.file && supportEntrySubcategory.file.isImage
        ? IconType.Image
        : supportEntrySubcategory.file
            ? getFileTypeIcon(supportEntrySubcategory.file.name)
            : supportEntrySubcategory?.link && supportEntrySubcategory?.link.length > 0
                ? IconType.Link
                : IconType.Information;

    const getLink = (text: string, onClick: () => void) => {
        return mobileView
            ? <Tooltip id={text} text={text}><Link text={text} onClick={onClick} /></Tooltip>
            : <Link text={text} onClick={onClick} />;
    };

    const getSubcategoryContent = () => {
        return <>
            {supportEntrySubcategory?.description?.length && <div className='description'>{supportEntrySubcategory.description}</div>}
            {supportEntrySubcategory.link && (supportEntrySubcategory.link.length > 0)
                && getLink(supportEntrySubcategory.link ? supportEntrySubcategory.link : '', () => window.open(supportEntrySubcategory.link, '_blank'))}
        </>;
    };

    const getSubcategoryTitle = (text: string) => {
        return mobileView
            ? <Tooltip id={text} text={text}>{text}</Tooltip>
            : <div>{text}</div>;
    };

    return (
        <div className={`support-entry-subcategory-card  ${mobileView ? ' mobile' : ''}`}>
            <Flex key={supportEntrySubcategory.id} direction={FlexDirection.Row} justification={FlexJustification.FlexStart} wrap={FlexWrap.NoWrap}>
                <div className='graphic'><Icon type={iconType} /></div>
                <div className='title'>{getSubcategoryTitle(supportEntrySubcategory.name)}</div>
            </Flex>
            {getSubcategoryContent()}
            {supportEntrySubcategory.file && supportEntrySubcategory.file.isImage
                ? <img src={getProductFileImage(supportEntrySubcategory.file)}></img>
                : supportEntrySubcategory?.file?.name && getLink(supportEntrySubcategory?.file?.name, () => handleFileGet(supportEntrySubcategory.file.md5Value, supportEntrySubcategory.file.name))
            }
        </div>
    );
};

export default SupportEntrySubcategoryCard;
